<template>

    <div class="l-button-container">
      <!-- 默认：default   置灰：disabled   选中：active   正确：correct   错误：error  -->
      <button 
        class="l-btn-default l-btn-type-1"
        type="button"
        :class="{
          'disabled': optionStatus == 1, 
          'default': optionStatus == 2, 
          'active': optionStatus == 3 && index == optionIndex, 
          'correct': optionStatus == 4 && item.isRight == 1 && index == optionIndex, 
          'error': optionStatus == 4 && item.isRight == 0 && index == optionIndex}"
        v-for="(item, index) in selectionlist" 
        :key="index"
        @click="onSelect(item, index)" >
        <span class="l-btn-text">
          {{ item.name}}
        </span>
        <img 
          class="right-img" 
          v-if="item.isRight == 1 
                && optionStatus == 4 
                && index != optionIndex" 
          src="./images/right.png" alt="" />
      </button>
    </div>
</template>

<script>
export default {
  name: 'l-button-choice',
  props: {
    selectionlist: {
      type: Array
    },
    status:{
      type: Number // 1：播放题干音/选项音时  2：可以选择  3：选中   4：返回正确/错误
    }
  },
  data() {
    return {
      optionStatus: 1,
      optionIndex: -1, // 选中坐标
      timer: null // 定时器
    }
  },
  watch:{
    status(val) {
      this.optionStatus = val
    }
  },
  created() {
    this.optionStatus = this.status
  },
  methods: {
    onSelect(item, index) {
      if (this.optionStatus == 2 && this.optionIndex == -1) {
        this.optionIndex = index
        this.optionStatus = 3
        this.timer = setTimeout(() => {
          this.optionStatus = 4
        }, 200)
        this.$emit('select', item)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
@import '../../style/l-btn.styl'
</style>
